import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import { getAllPackages} from '../../services/getAllApi'; // Import APIs
import {updatePackages} from '../../services/getAdminApi'
import { IconButton } from '@mui/material';
import {Edit } from '@mui/icons-material';

const AddPackages = () => {
  const [packages, setPackages] = useState([]);
  const [formData, setFormData] = useState({
    package_type: '',
    amount: '',
  });
  const [editingId, setEditingId] = useState(null);

  // Fetching packages from the API
  useEffect(() => {
    fetchPackages();
  }, []);

  const fetchPackages = async () => {
    try {
      const response = await getAllPackages();
      setPackages(Array.isArray(response.data.data) ? response.data.data : []);
    } catch (error) {
      Swal.fire('Error', 'Failed to fetch packages', 'error');
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSave = async () => {
    if (!formData.package_type || !formData.amount) {
      Swal.fire('Validation Error', 'Please fill all required fields', 'error');
      return;
    }

    const payload = {
      package_type: formData.package_type,
      amount: formData.amount,
    };

    try {
      if (editingId !== null) {
        const confirmEdit = await Swal.fire({
          title: 'Are you sure?',
          text: 'Do you want to update this package?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, update it!',
        });

        if (confirmEdit.isConfirmed) {
          await updatePackages(payload);
          Swal.fire('Success', 'Package updated successfully', 'success');
        }
      }

      // Reset form
      setFormData({
        package_type: '',
        amount: '',
      });
      setEditingId(null);
      fetchPackages(); // Fetch the updated packages after save
    } catch (error) {
      Swal.fire('Error', 'Failed to save package', 'error');
    }
  };

  const handleEdit = (pkg) => {
    Swal.fire({
      title: 'Edit Package',
      text: `Do you want to edit the ${pkg.package_type} package?`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Yes, edit',
    }).then((result) => {
      if (result.isConfirmed) {
        setEditingId(pkg.id);
        setFormData({
          package_type: pkg.package_type,
          amount: pkg.amount,
        });
      }
    });
  };

  return (
    <div>
      <div className="dashboard-heading-div">
        <p>Manage Packages</p>
      </div>

      <div className="editing-container">
        <div>
          <h2 className="editing-container-heading">
            {editingId !== null ? 'Edit Package' : 'Create Package'}
          </h2>

          <div className="editing-container-form">
            <div className="editing-container-input-div">
              <label>Package Type:</label>
              <input
                name="package_type"
                value={formData.package_type}
                disabled
              />
            </div>

            <div className="editing-container-input-div">
              <label>Amount:</label>
              <input
                name="amount"
                value={formData.amount}
                onChange={handleInputChange}
                required
                placeholder="Enter Amount"
                type="text"
              />
            </div>
          </div>
        </div>
        <button variant="contained" color="primary" onClick={handleSave}>
          {editingId !== null ? 'Update' : 'Save'} <i className="bx bx-send"></i>
        </button>
      </div>

      <div className="table-container-registered-alumni">
        <table>
          <thead>
            <tr>
              <th>Package Type</th>
              <th>Amount</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {packages.map((pkg) => (
              <tr key={pkg.id}>
                <td>{pkg.package_type}</td>
                <td>{pkg.amount}</td>
                <td>
                     <IconButton color="primary" onClick={() => handleEdit(pkg)}>
                                        <Edit />
                                      </IconButton>
                 
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AddPackages;
